import { Dialog, DialogContent } from "@tellescope/ui";
import { Spinner } from "@tellescope/design-system";
import { SetupDialogHeader } from "./SetupDialogHeader";
import { SelectIntegrationsStep } from "./plan-dialogs/steps";
import { useSetupDialogFlow, type UseSetupDialogFlowArgs } from "./useSetupDialogFlow";

export type SetupDialogFlowProps = UseSetupDialogFlowArgs;

export const SetupDialogFlow = ({ onSuccess, onError }: SetupDialogFlowProps) => {
  const {
    plan,
    showSelection,
    currentStep,
    selectedIntegrationNames,
    completedIntegrationNames,
    onComplete,
    onBack,
    onSelectionContinue,
    onSkipStep,
  } = useSetupDialogFlow({ onSuccess, onError });

  const StepComponent = currentStep?.step.Component;
  // Required steps hide the skip control by receiving no skip handler.
  const onSkip = currentStep?.step.required ? undefined : onSkipStep;

  return (
    <Dialog open>
      <DialogContent
        data-testid="onboarding-setup-dialog"
        divided
        className="overflow-hidden shadow-md"
        overlayVariant="light"
        showCloseButton={false}
        style={{
          width: "min(90svw, 1200px)",
          maxWidth: "min(90svw, 1200px)",
        }}
      >
        <SetupDialogHeader />
        {!plan ? (
          <div className="flex flex-col gap-4 items-center justify-center">
            <Spinner />
          </div>
        ) : showSelection ? (
          <SelectIntegrationsStep
            plan={plan}
            initialSelected={selectedIntegrationNames}
            onContinue={onSelectionContinue}
          />
        ) : StepComponent ? (
          <StepComponent
            selectedIntegrationNames={selectedIntegrationNames}
            completedIntegrationNames={completedIntegrationNames}
            onComplete={onComplete}
            onBack={onBack}
            onSkip={onSkip}
            onSuccess={onSuccess}
            onError={onError}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
